import { render, staticRenderFns } from "./HeaderModality.vue?vue&type=template&id=4ab74480"
import script from "./HeaderModality.vue?vue&type=script&lang=js"
export * from "./HeaderModality.vue?vue&type=script&lang=js"
import style0 from "./HeaderModality.vue?vue&type=style&index=0&id=4ab74480&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports